import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { PrivilegesService } from '../../../services/privileges.service';

@Component({
    selector: 'shared-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    providers: [PrivilegesService]
})
export class HeaderComponent {
    private isCollapsed = true;

    constructor(private router: Router,
        private authService: AuthenticationService,
        private privilegesService: PrivilegesService) {
    }

    display(): boolean {
        return !this.authService.isTokenExpired();
    }

    toggleState(): boolean {
        return this.isCollapsed = !this.isCollapsed;
    }

    isAuthorized(name: string): boolean {
        return this.privilegesService.isAuthorized(name);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/header/header.component.ts